/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import CustomPageError from '../../constant/CustomPageError';
import Error_image from '../../assets/Images/currency-not-found.png';
import Image from 'next/image';

const CurrencyNotFound = () => {
  return (
    <div className="  ">
      <CustomPageError
        error_code={'Currency Not Found'}
        messages_box={
          <div className="flex flex-col gap-2 ">
            <p className=" text-lg font-medium text-gray-800 ">
              We're sorry, but the page does not loading because of currency not
              found. There are several possible options to identify the issue:
            </p>
            <ul className="px-2  list-disc flex flex-col gap-2">
              <li className=" text-lg font medium text-gray-800 ">
                Please make sure you have minimum one currency in your
                application inside super admin.
              </li>
              <li className=" text-lg font medium text-gray-800 ">
                <span>
                  Please make sure you have minimum one currency selected as
                  default currency.
                </span>
                <div className=" h-[200px] w-auto  relative   ">
                  <Image
                    src={Error_image}
                    alt={'Image'}
                    title={'BlockerError_image'}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
              </li>
            </ul>
          </div>
        }
      />
    </div>
  );
};

export default CurrencyNotFound;
